import styles from "./ProjectNotification.module.css";
import Lottie from "lottie-react";
import Thumsup from "../../Users/Notification/Thumsup.json";
const ProjectNotification = ({ isVisible, setClose, message }) => {
  if (!isVisible) return null;
  return (
    <div className={styles.NotificationContainer}>
      <div className={styles.NotificationFirst}>
        <div
          onClick={() => {
            setClose();
          }}
        >
          <img
            className={styles.arrowNarrowLeftIcon}
            alt=""
            src="/x-complete-circle.svg"
          />
        </div>
      </div>
      <div className={styles.NotificationSecond}>
        <Lottie
          className={styles.httpslottiefilescomanimatIcon}
          animationData={Thumsup}
          loop={true}
        />
      </div>
      <div className={styles.NotificationThird}>{message}</div>
    </div>
  );
};
export default ProjectNotification;
